<template>
    <modal name="LevelModal"
           transition="nice-modal-fade"
           :min-width="360"
           :min-height="150"
           :pivot-y="0.4"
           :adaptive="true"
           :reset="true"
           height="auto">
        <div class="popupcontainer container">
            <div class="btn-close">
                <svg width="14px" height="14px" viewBox="0 0 12 12" xmlSpace="preserve" @click="close()">
                    <line x1="1" y1="11" x2="11" y2="1" style="stroke-linecap: round; stroke-linejoin: round;"></line>
                    <line x1="1" y1="1" x2="11" y2="11" style="stroke-linecap: round; stroke-linejoin: round;"></line>
                </svg>
            </div>
            <div class="modalHeader">
                <h4>
                    레벨안내
                </h4>
            </div>
            <br/>
            <h5 style="margin-left: 20px;">레벨 등급 및 기준 안내</h5>
            <table class="lvTable table table-borderless text-center">
                <thead>
                    <th scope="col">등급</th>
                    <th scope="col">봉사시간</th>
                </thead>
                <tbody>
                    <tr v-for="lv in $root.$children[0].getLevel()">
                        <td><span class="badge badge-pill" :style="`color:white;background-color:`+lv.color">{{lv.name}}</span></td>
                        <td>{{hour(lv.min)}}시간 이상</td>
                    </tr>
                    <!--<tr>
                        <td>Lv.1 <span class="badge badge-pill badge-secondary" style="font-size:12px">1</span></td>
                        <td>100분 이상</td>
                    </tr>
                    <tr>
                        <td>Lv.2 <span class="badge badge-pill badge-success" style="font-size:12px">2</span></td>
                        <td>200분 이상</td>
                    </tr>
                    <tr>
                        <td>Lv.3 <span class="badge badge-pill badge-primary" style="font-size:12px">3</span></td>
                        <td>300분 이상</td>
                    </tr>
                    <tr>
                        <td>Lv.4 <span class="badge badge-pill badge-danger" style="font-size:12px">4</span></td>
                        <td>400분 이상</td>
                    </tr>
                    <tr>
                        <td>Lv.5 <span class="badge badge-pill badge-warning" style="font-size:12px">5</span></td>
                        <td>500분 이상</td>
                    </tr>-->
                </tbody>
            </table>
            <div style="margin-left: 20px;">
                <p><span class="badge badge-pill badge-secondary" style="font-size:12px">!</span> 유의사항</p>
                <p class="text-justify">- 레벨 등급은 상황에 따라 변경 될 수 있습니다. </p>
            </div>
            <div class="modalFooter text-center">
                <h6 role="button" @click="close()">닫기</h6>
            </div>
        </div>
    </modal>
</template>

<script>

    export default {
        name: "LevelModal",
        methods: {
            close() {
                this.$modal.hide('LevelModal')
            },
            hour(min) {
                return Math.floor(min / 60);
            },
        },
        mounted() {
        },
        created() {

        },
    }
</script>

<style scoped>
    .popupcontainer {
        overflow-y: auto;
        border-radius: 5px;
        background: #F7F7F7;
        max-height: 600px;
    }
    .btn-close {
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
        position: absolute;
        right: 20px;
        top: 5px;
    }
    .btn-close line {
        stroke: grey;
        stroke-width: 2;
    }
    .btn-close:hover line {
        stroke: black;
    }
    .modalHeader {
        border-bottom: 1px solid #EEE;
        padding: 1em;
        text-align: left;
    }
    .modalFooter {
        border-top: 1px solid #EEE;
        padding: 1em;
        text-align: center;
    }
    .lvTable td, th{
      padding : 1px;
    }
</style>